/**
 * `Footer` — footer globale dell'applicazione, mostrato in tutte le pagine.
 *
 * Layout su una sola riga: il blocco legale (copyright + P.IVA) è allineato a
 * sinistra, tutto il resto (versione, link al changelog, attribuzione) è
 * allineato a destra. Il contenuto è centrato entro un container con la stessa
 * `max-width` della shell applicativa (`--container-max`) e separato dal
 * contenuto da una linea superiore (border-top).
 */
import { Link } from 'react-router-dom';
import { APP_VERSION, APPFACTORY_URL, CHANGELOG_PATH } from '../appInfo';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        <p className="app-footer__legal">
          © {year} Appfactory S.r.l. Tutti i diritti riservati. P.IVA 02115600997
        </p>
        <p className="app-footer__meta">
          <span className="app-footer__version">{APP_VERSION}</span>
          <span className="app-footer__sep" aria-hidden="true">
            |
          </span>
          <Link className="app-footer__link" to={CHANGELOG_PATH}>
            Changelog
          </Link>
          <span className="app-footer__sep" aria-hidden="true">
            |
          </span>
          <span className="app-footer__powered">
            Powered by{' '}
            <a
              className="app-footer__link"
              href={APPFACTORY_URL}
              target="_blank"
              rel="noreferrer noopener"
            >
              appfactory
            </a>. Accelerate. Achieve. Scale
          </span>
        </p>
      </div>
    </footer>
  );
}
